import { z } from 'zod';
import React, { FC } from 'react';
import { useForm, FormProvider as FormProviderRHF } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { MediumConfig } from '../types';
import { schema, messageTypeMergedSchema } from './FormProvider.schema';
import { createDefaultValues } from './FormProvider.defaultValues';
import {
  CAPPING_PERIOD,
  CAPPING_MAX_ALLOWED,
  OPTIMIZE_PERIOD,
  OPTIMIZE_MIN_ALLOWED,
  OPTIMIZE_MAX_ALLOWED,
  MODE,
  MESSAGE_TYPES,
} from './FormProvider.constants';

export type MessageMediumFormKey =
  | typeof CAPPING_PERIOD
  | typeof CAPPING_MAX_ALLOWED
  | typeof OPTIMIZE_PERIOD
  | typeof OPTIMIZE_MIN_ALLOWED
  | typeof OPTIMIZE_MAX_ALLOWED
  | typeof MODE;
export type MessageTypeFormKey = `${typeof MESSAGE_TYPES}.${number}.${MessageMediumFormKey}`;

export type SchemaFormKeys = MessageMediumFormKey | MessageTypeFormKey;

export type FrequencyManagementSchema = Required<z.infer<typeof schema>>;

export type MessageTypeSchema = Required<z.infer<typeof messageTypeMergedSchema>>;

type Props = {
  mediumConfig: MediumConfig;
};

export const FormProvider: FC<React.PropsWithChildren<Props>> = ({ children, mediumConfig }) => {
  /** @ts-ignore */
  const defaultValues = createDefaultValues(mediumConfig);
  const methods = useForm<FrequencyManagementSchema>({
    defaultValues,
    mode: 'all',
    resolver: zodResolver(schema),
  });

  return <FormProviderRHF {...methods}>{children}</FormProviderRHF>;
};

export {
  MODE,
  CAPPING_PERIOD,
  CAPPING_MAX_ALLOWED,
  OPTIMIZE_PERIOD,
  OPTIMIZE_MIN_ALLOWED,
  OPTIMIZE_MAX_ALLOWED,
  MESSAGE_TYPES,
  ID,
  INDEX,
  NAME,
  CHANNEL_NAME,
  INITIAL_MODE,
} from './FormProvider.constants';
